import { css } from 'linaria';

export const questionAccordion = css`
  && {
    width: 877px;

    @media (--to-desktop) {
      width: 100%;
    }
  }
`;

export const questionText = css`
  margin-bottom: 8px;
`;

export const questionSignLink = css`
  && {
    display: inline;
    color: var(--brand-dark);

    &:hover {
      color: var(--control-hover-accent);
    }
  }
`;

export const questionList = css`
  padding: 0;
  margin: 0;
  list-style: none;
  counter-reset: counter;
`;

export const questionListItem = css`
  position: relative;
  padding-left: 44px;
  margin-bottom: 8px;
  white-space: break-spaces;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 100%;
    font-size: 14px;
    line-height: 20px;
    counter-increment: counter;
    content: counter(counter);
  }
`;

export const questionSignButton = css`
  margin-top: 16px;
  margin-bottom: 8px;

  @media (--to-desktop) {
    display: none;
  }
`;
